module.exports = __webpack_public_path__ + "static/media/logo-auto.9a02bd2e.svg";